<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,783.5l10,4v4l-10,4l-10-4v-4L0.5,783.5z M0.5,785.5l-7.5,3l7.5,3l7.5-3L0.5,785.5z M10.5,793.5v4l-10,4l-10-4v-4l10,4
	L10.5,793.5z"/>
</svg>

</template>